export enum NotificationType {
  Prenotification = 'Prenotification',
  Alert = 'Alert',
  Postnotification = 'Postnotification',
  StatementPreNotification = 'StatementPreNotification',
  Error = 'Error',
  Warning = 'Warning',
}
